// Hands a login-as token over to a new tab: the token is stored in localStorage under a random key
// and only that key is put in the url, so other tabs never pick it up and it never appears in the url.
// The tab is opened synchronously in the click (before the socket call), otherwise Safari blocks it as a popup.

import {clearStoredDates} from './storedDates.js'

const keyPrefix = 'loginAsToken_'
const urlParam = 'loginAs'
const maxAge = 60 * 1000

export function openHandoverTab() {
    return window.open('', '_blank')
}

export function closeHandoverTab(win) {
    if (win && !win.closed) {
        win.close()
    }
}

export function sendToken(win, token, url = '/') {
    const key = Array.from(crypto.getRandomValues(new Uint8Array(16)), (byte) => byte.toString(16).padStart(2, '0')).join('')
    localStorage.setItem(keyPrefix + key, JSON.stringify({token, createdAt: Date.now()}))

    const target = new URL(url, window.location.origin)
    target.searchParams.set(urlParam, key)
    const href = `${target.pathname}${target.search}${target.hash}`

    if (win && !win.closed) {
        win.location.href = href
    } else {
        // The tab could not be opened in the click (blocked or not expected), try again
        window.open(href)
    }
}

const readHandover = (key) => {
    try {
        const handover = JSON.parse(localStorage.getItem(key))
        return handover && Date.now() - handover.createdAt <= maxAge ? handover : null
    } catch {
        return null
    }
}

// Must run before socketio.js is imported, so the socket connects with the handed over token
export function consumeHandover() {
    // Keys of the previous implementation, never use them
    localStorage.removeItem('loginAsCustomerToken')
    localStorage.removeItem('loginAsResellerToken')

    const keys = []
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key?.startsWith(keyPrefix)) {
            keys.push(key)
        }
    }
    keys.filter((key) => !readHandover(key)).forEach((key) => localStorage.removeItem(key))

    const params = new URLSearchParams(window.location.search)
    const key = params.get(urlParam)

    if (!key) {
        return
    }

    const handover = readHandover(keyPrefix + key)
    localStorage.removeItem(keyPrefix + key)
    params.delete(urlParam)

    // A new login: the dates picked in the tab that opened this one (its sessionStorage is copied) do not apply
    clearStoredDates()

    if (handover) {
        sessionStorage.setItem('token', handover.token)
        sessionStorage.setItem('noDomainRedirect', 'true')

        const search = params.toString()
        window.history.replaceState(null, '', `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`)
    } else {
        // Never continue with the session copied from the tab that opened this one
        sessionStorage.removeItem('token')
        window.history.replaceState(null, '', '/login')
    }
}

export function isAdminToken(token) {
    try {
        const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
        return !!JSON.parse(atob(payload)).isAdmin
    } catch {
        return false
    }
}
